import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ARTICLES = [
  { titleKey: "p1Title", descKey: "p1Desc", icon: "ri-star-line" },
  { titleKey: "p2Title", descKey: "p2Desc", icon: "ri-truck-line" },
  { titleKey: "p3Title", descKey: "p3Desc", icon: "ri-coupon-3-line" },
  { titleKey: "p4Title", descKey: "p4Desc", icon: "ri-percent-line" },
  { titleKey: "p5Title", descKey: "p5Desc", icon: "ri-archive-line" },
  { titleKey: "p6Title", descKey: "p6Desc", icon: "ri-shield-check-line" },
  { titleKey: "p7Title", descKey: "p7Desc", icon: "ri-search-eye-line" },
  { titleKey: "p8Title", descKey: "p8Desc", icon: "ri-shopping-bag-line" },
  { titleKey: "p9Title", descKey: "p9Desc", icon: "ri-shield-star-line" },
  { titleKey: "p10Title", descKey: "p10Desc", icon: "ri-map-pin-line" },
];

export default function PillarArticles() {
  const { t } = useTranslation();

  return (
    <section id="pillars" className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-20">
      <div className="text-center">
        <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          {t("pillarH2")}
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-base text-foreground-600">{t("pillarSub")}</p>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 lg:gap-5">
        {ARTICLES.map((article, i) => (
          <Link
            key={article.titleKey}
            to="/usfans-spreadsheet-guide"
            className="group flex items-start gap-4 rounded-lg border border-background-200 bg-white p-5 transition-transform duration-300 hover:-translate-y-1"
          >
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-accent-100 text-accent-700">
              <i className={`${article.icon} text-lg`}></i>
            </span>
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2">
                <span className="whitespace-nowrap text-xs font-semibold text-foreground-400">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="font-heading text-sm font-semibold text-foreground-950 md:text-base">
                  {t(article.titleKey)}
                </h3>
              </div>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                {t(article.descKey)}
              </p>
              <span className="mt-3 inline-flex items-center gap-1 whitespace-nowrap text-xs font-semibold text-primary-600 md:text-sm">
                {t("pillarRead")}
                <span className="flex h-4 w-4 items-center justify-center transition-transform group-hover:translate-x-0.5">
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}